module.exports = __webpack_public_path__ + "static/media/kd.637cbb29.png";